import { type ActivityEventPriority } from '@libraries/typescript/api_client';

// Tailwind classes per priority. Shared by the homepage activity feed
// row badge and the call detail dialog notes section so badge color is
// consistent everywhere a priority is displayed.
const PRIORITY_BADGE_CLASSES: Readonly<Record<ActivityEventPriority, string>> =
    {
        urgent: 'border-red-200 bg-red-100 text-red-800',
        high: 'border-amber-200 bg-amber-100 text-amber-800',
        normal: 'border-gray-200 bg-gray-100 text-gray-800',
        low: 'border-gray-200 bg-gray-50 text-gray-500',
    };

const PRIORITY_LABELS: Readonly<Record<ActivityEventPriority, string>> = {
    urgent: 'Urgent',
    high: 'High',
    normal: 'Normal',
    low: 'Low',
};

export function priorityBadgeClasses(priority: ActivityEventPriority): string {
    return PRIORITY_BADGE_CLASSES[priority];
}

export function priorityLabel(priority: ActivityEventPriority): string {
    return PRIORITY_LABELS[priority];
}
